import { formatList } from "@memorang/helpers/i18n";
import type { TFunction } from "i18next";
import type { ExploreFilterState } from "./types";

type Params = {
	t: TFunction;
	locale: string;
	hiddenLessons: number;
	hasSearchQuery: boolean;
	filterState: ExploreFilterState;
};

type EmptyStateConfig = {
	title: string;
	subtitle: string;
	cta: string;
};

export const getExploreEmptyState = ({
	t,
	locale,
	hiddenLessons,
	hasSearchQuery,
	filterState,
}: Params): EmptyStateConfig => {
	if (hasSearchQuery) {
		return {
			title: t("lessons.explore.empty.searchTitle", { count: hiddenLessons }),
			subtitle: t("lessons.explore.empty.searchSubtitle"),
			cta: t("lessons.explore.empty.searchCta"),
		};
	}

	const activeFilterNames = [
		filterState.isPremiumSelected && t("lessons.explore.filterNames.premium"),
		filterState.isCompletedSelected &&
			t("lessons.explore.filterNames.completed"),
		filterState.selectedTopics.length > 0 &&
			t("lessons.explore.filterNames.topics"),
	].filter((name): name is string => Boolean(name));

	if (activeFilterNames.length > 0) {
		return {
			title: t("lessons.explore.empty.filtersTitle", { count: hiddenLessons }),
			subtitle: t("lessons.explore.empty.filtersSubtitle", {
				count: activeFilterNames.length,
				filters: formatList(locale, activeFilterNames, {
					type: "disjunction",
				}),
			}),
			cta: t("lessons.explore.empty.filtersCta"),
		};
	}

	return {
		title: t("lessons.explore.empty.noneTitle"),
		subtitle: t("lessons.explore.empty.noneSubtitle"),
		cta: t("lessons.explore.empty.noneCta"),
	};
};
